export const ChipIcon = (props: {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.width}
      height={props.height}
      style={props.style}
      viewBox="0 0 414 413"
      enableBackground="new 0 0 414 413"
    >
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
          M193.000000,1.000001 
          C202.687561,1.000000 212.375122,1.000000 222.693176,1.404686 
          C233.622833,3.206531 244.038086,4.036597 254.197449,6.116545 
          C276.736023,10.730921 297.646545,19.801489 317.166077,31.799417 
          C338.266418,44.768997 356.183929,61.463268 371.453247,80.964165 
          C383.626129,96.510460 393.384430,113.441772 400.445679,131.908554 
          C408.595154,153.221161 413.940796,175.099915 414.044800,198.067902 
          C414.047699,198.713348 414.667694,199.356033 415.000000,200.000000 
          C415.000000,204.689255 415.000000,209.378510 414.592163,214.700104 
          C413.457153,223.480759 412.980957,231.660904 411.952881,239.771072 
          C409.488678,259.210144 403.447083,277.595886 395.267395,295.361664 
          C388.423523,310.226135 379.975098,324.153076 369.542236,336.641937 
          C361.043854,346.815125 351.935577,356.710480 341.869843,365.288177 
          C326.911987,378.034821 310.320526,388.585846 292.137054,396.449707 
          C274.485077,404.083710 256.307465,409.697479 237.165710,412.026581 
          C233.090759,412.522369 229.054230,413.333923 225.000000,414.000000 
          C213.979111,414.000000 202.958206,414.000000 191.308701,413.596680 
          C180.092850,411.617279 169.376450,410.629913 158.945602,408.341217 
          C137.931351,403.730347 118.542686,394.848999 100.056526,383.987885 
          C81.199142,372.908630 65.090080,358.362885 50.852512,342.042175 
          C35.978035,324.991333 24.344460,305.655365 16.054600,284.441071 
          C7.627790,262.876343 2.413776,240.665817 1.960450,217.429337 
          C1.925034,215.613998 1.333218,213.809525 0.999999,212.000000 
          C1.000000,209.299988 1.000000,206.599976 1.408376,203.283051 
          C2.875145,191.939545 3.709453,181.185043 5.041646,170.492569 
          C7.347774,151.983063 13.717508,134.637009 21.673180,117.949799 
          C29.188194,102.186867 38.623264,87.564278 50.120220,74.279663 
          C62.415009,60.073147 75.612480,46.813305 91.649094,36.975891 
          C104.343193,29.188887 117.429459,21.812424 131.015518,15.768652 
          C146.453522,8.901038 162.896591,4.741063 179.832382,2.967462 
          C184.241913,2.505674 188.611862,1.666074 193.000000,1.000001 
          M179.707047,127.211678 
          C156.717026,148.935760 133.705551,170.637207 110.752029,192.399811 
          C104.989182,197.863647 105.990433,205.521210 112.993919,209.493210 
          C119.931915,213.428055 127.011841,217.112305 134.021042,220.922028 
          C147.862656,228.445389 161.698456,235.979477 175.692108,243.593719 
          C174.979172,245.485382 174.468338,247.054642 173.809006,248.558807 
          C160.071198,279.899445 146.324524,311.236176 132.557785,342.564117 
          C130.074615,348.214874 130.853561,352.858459 134.948349,356.064697 
          C138.701324,359.003235 143.840118,358.843567 148.325241,355.563354 
          C200.053101,317.732361 251.782303,279.903229 303.487457,242.041260 
          C311.695526,236.030746 310.741699,227.268768 301.461151,223.009033 
          C287.720734,216.702255 273.952850,210.455215 260.185822,204.206573 
          C248.110855,198.725967 236.020996,193.278183 223.795059,187.751404 
          C226.825378,179.601883 229.710907,171.829803 232.604889,164.060867 
          C244.196274,132.943710 255.794235,101.829025 267.378876,70.709381 
          C269.010803,66.325569 267.473450,61.344856 263.741547,58.719021 
          C259.607574,55.810268 254.334000,56.366222 250.127991,60.351925 
          C226.804840,82.453392 203.513962,104.588928 179.707047,127.211678 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
            M192.531342,1.000001 
            C188.611862,1.666074 184.241913,2.505674 179.832382,2.967462 
            C162.896591,4.741063 146.453522,8.901038 131.015518,15.768652 
            C117.429459,21.812424 104.343193,29.188887 91.649094,36.975891 
            C75.612480,46.813305 62.415009,60.073147 50.120220,74.279663 
            C38.623264,87.564278 29.188194,102.186867 21.673180,117.949799 
            C13.717508,134.637009 7.347774,151.983063 5.041646,170.492569 
            C3.709453,181.185043 2.875145,191.939545 1.408376,202.833069 
            C1.000000,135.741486 1.000000,68.482979 1.000000,1.000000 
            C64.687386,1.000000 128.375031,1.000000 192.531342,1.000001 
            z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
            M415.000000,199.531342 
            C414.667694,199.356033 414.047699,198.713348 414.044800,198.067902 
            C413.940796,175.099915 408.595154,153.221161 400.445679,131.908554 
            C393.384430,113.441772 383.626129,96.510460 371.453247,80.964165 
            C356.183929,61.463268 338.266418,44.768997 317.166077,31.799417 
            C297.646545,19.801489 276.736023,10.730921 254.197449,6.116545 
            C244.038086,4.036597 233.622833,3.206531 223.161835,1.404686 
            C286.928314,1.000000 350.856659,1.000000 415.000000,1.000000 
            C415.000000,67.020737 415.000000,133.041718 415.000000,199.531342 
            z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
            M0.999999,212.468658 
            C1.333218,213.809525 1.925034,215.613998 1.960450,217.429337 
            C2.413776,240.665817 7.627790,262.876343 16.054600,284.441071 
            C24.344460,305.655365 35.978035,324.991333 50.852512,342.042175 
            C65.090080,358.362885 81.199142,372.908630 100.056526,383.987885 
            C118.542686,394.848999 137.931351,403.730347 158.945602,408.341217 
            C169.376450,410.629913 180.092850,411.617279 190.840042,413.596680 
            C127.737404,414.000000 64.474800,414.000000 1.000000,414.000000 
            C1.000000,346.979248 1.000000,279.958282 0.999999,212.468658 
            z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
            M225.468658,414.000000 
            C229.054230,413.333923 233.090759,412.522369 237.165710,412.026581 
            C256.307465,409.697479 274.485077,404.083710 292.137054,396.449707 
            C310.320526,388.585846 326.911987,378.034821 341.869843,365.288177 
            C351.935577,356.710480 361.043854,346.815125 369.542236,336.641937 
            C379.975098,324.153076 388.423523,310.226135 395.267395,295.361664 
            C403.447083,277.595886 409.488678,259.210144 411.952881,239.771072 
            C412.980957,231.660904 413.457153,223.480759 414.592163,215.166214 
            C415.000000,281.258667 415.000000,347.517365 415.000000,414.000000 
            C351.979279,414.000000 288.958313,414.000000 225.468658,414.000000 
            z"
      />
      <path
        fill="#FBC701"
        opacity="1.000000"
        stroke="none"
        d="
              M179.959534,126.962234 
              C203.513962,104.588928 226.804840,82.453392 250.127991,60.351925 
              C254.334000,56.366222 259.607574,55.810268 263.741547,58.719021 
              C267.473450,61.344856 269.010803,66.325569 267.378876,70.709381 
              C255.794235,101.829025 244.196274,132.943710 232.604889,164.060867 
              C229.710907,171.829803 226.825378,179.601883 223.795059,187.751404 
              C236.020996,193.278183 248.110855,198.725967 260.185822,204.206573 
              C273.952850,210.455215 287.720734,216.702255 301.461151,223.009033 
              C310.741699,227.268768 311.695526,236.030746 303.487457,242.041260 
              C251.782303,279.903229 200.053101,317.732361 148.325241,355.563354 
              C143.840118,358.843567 138.701324,359.003235 134.948349,356.064697 
              C130.853561,352.858459 130.074615,348.214874 132.557785,342.564117 
              C146.324524,311.236176 160.071198,279.899445 173.809006,248.558807 
              C174.468338,247.054642 174.979172,245.485382 175.692108,243.593719 
              C161.698456,235.979477 147.862656,228.445389 134.021042,220.922028 
              C127.011841,217.112305 119.931915,213.428055 112.993919,209.493210 
              C105.990433,205.521210 104.989182,197.863647 110.752029,192.399811 
              C133.705551,170.637207 156.717026,148.935760 179.959534,126.962234 
              z"
      />
    </svg>
  );
};
